var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Landing'),_c('Summary'),_c('Responsive'),_c('PricePrev'),_c('Steps')],1)}
var staticRenderFns = []

export { render, staticRenderFns }